'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component = require('../../Component');

var _Component2 = _interopRequireDefault(_Component);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _main = require('../templates/main');

var _main2 = _interopRequireDefault(_main);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set;

if (!nativeInputValueSetter) {
    nativeInputValueSetter = function nativeInputValueSetter(value) {
        this.value = value;
    };
}

var Main = function (_View) {
    _inherits(Main, _View);

    function Main(props) {
        var _ret;

        _classCallCheck(this, Main);

        var _this = _possibleConstructorReturn(this, (Main.__proto__ || Object.getPrototypeOf(Main)).call(this, props));

        _this.template = _main2.default;


        _this.state = {
            focus: false,
            hover: false,
            height: null
        };

        return _ret = _this, _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Main, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.syncHeight();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState, prevContext) {
            if (prevProps.value !== this.props.value) {
                this.syncHeight();
            }

            return this;
        }

        /**
         * обработчик фокуса
         * @param {object} event
         * @return {object}
         * @private
         */

    }, {
        key: '_handleFocus',
        value: function _handleFocus(event) {
            var _this2 = this;

            this.setState({
                focus: true
            }).then(function () {
                if (typeof _this2.props.onFocus === 'function') {
                    _this2.props.onFocus(event);
                }
            });

            return this;
        }

        /**
         * обработчик блюра
         * @param {object} event
         * @return {object}
         * @private
         */

    }, {
        key: '_handleBlur',
        value: function _handleBlur(event) {
            var _this3 = this;

            this.setState({
                focus: false
            }).then(function () {
                if (typeof _this3.props.onBlur === 'function') {
                    _this3.props.onBlur(event);
                }
            });

            return this;
        }
    }, {
        key: '_nativeElementRef',
        value: function _nativeElementRef(el) {
            if (typeof this.props.elementRef === 'function') {
                this.props.elementRef(el);
            }

            this.nativeElement = el;
        }
    }, {
        key: '_shadowRef',
        value: function _shadowRef(el) {
            this.shadow = el;
        }
    }, {
        key: 'computeStyleHash',
        value: function computeStyleHash() {
            return _get(Main.prototype.__proto__ || Object.getPrototypeOf(Main.prototype), 'computeStyleHash', this).call(this) + String(this.props.floating) + String(!!this.props.value) + String(this.state.focus) + String(this.state.hover) + String(this.props.error) + String(this.props.disabled || this.props.readOnly);
        }
    }, {
        key: '_handleHover',
        value: function _handleHover() {
            return this.setState({ hover: true });
        }
    }, {
        key: '_handleRootBlur',
        value: function _handleRootBlur() {
            return this.setState({ hover: false });
        }
    }, {
        key: 'syncHeight',
        value: function syncHeight() {
            var height = this.shadow.scrollHeight,
                maxHeight = void 0,
                newHeight = void 0;

            if (this.props.rows > 1 && this.lineHeight) {
                height = this.props.rows * this.lineHeight;
            }

            if (this.props.rowsMax && this.lineHeight) {
                maxHeight = Number(this.props.rowsMax) * this.lineHeight;
            }

            newHeight = maxHeight ? Math.min(height, maxHeight) : height;

            if (this.state.height !== newHeight) {
                this.setState({
                    height: newHeight
                });
            }

            return this;
        }
    }, {
        key: '_stringify',
        value: function _stringify() {
            if (this.props.value === null || this.props.value === undefined) {
                return '';
            } else {
                return this.props.value;
            }
        }
    }, {
        key: 'value',
        get: function get() {
            return this.props.value;
        },
        set: function set(value) {
            nativeInputValueSetter.call(this.nativeElement, value || '');
            this.nativeElement.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }]);

    return Main;
}(_Component2.default);

Main.defaultProps = {
    label: '',
    // components placeholder
    placeholder: '',
    onBlur: null,
    onFocus: null,
    // floating label
    floating: true,
    rows: 1
};
Main.propTypes = {
    label: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    onBlur: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    floating: _propTypes2.default.bool,
    rows: _propTypes2.default.number
};
Main.displayName = 'TextArea';
exports.default = Main;